import { INavigationConfig } from '~/src/dash/views/common';

export const channelsNavigationConfig: INavigationConfig = {
  tabs: [
    { key: 'All', tKey: 'All', label: 'All', value: 0 },
    { key: 'Groups', tKey: 'Groups', label: 'Groups', value: 1 },
    { key: 'Mappings', tKey: 'Mappings', label: 'Mappings', value: 2 },
  ],
};
